<script>
import { user } from "./userStore.js";
import CodeReview from "./CodeReview.svelte";
export let tip;
export let isFromTeacher = false;

let vimeoAvailable = false;

function setTipViewed(tip) {
  if (!isFromTeacher) {
    console.log('viewed');
    tip.viewed = true;
    user.saveTipToUser(tip);     
  }
}

// src="https://fast.wistia.net/embed/iframe/1qya69feuu?fullscreenButton=true"
window._wq = window._wq || [];
// _wq.push({ id: "1qya69feuu", onReady: function(video) {
//   console.log("I got a handle to the video!", video);
// }});
_wq.push({ id: "_all", onReady: function(video) {
console.log("This will run for every video on the page. Right now I'm on this one:", video);
vimeoAvailable = true;
}});
</script>

<style>

  .card {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    /* transition: 0.8s; */
    transition: all 0.3s;
    display: inline-block;
    vertical-align: top;
    margin: 10px;
    max-width: 200px;
    padding: 15px;
    border-radius: 10px;
    position: relative;
  }

  .card.expanded {
    width: 100%;
    /* height: 100%; */
    position: relative;
    top: 0;
    margin-top: 0;
    left: 0;
    margin-left: 0;
    /* max-width: 60%; */
    max-width: 70%;
    /* border-radius: 20px; */
    border-radius: 20px 0px 20px 20px;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.5);
  }

  .card.tip {
    background-color: hsl(300, 100%, 27%);
    color: hsl(300, 100%, 67%);
  }

  .card.tip.short {
    color: #fff;
  }

  .card.tip.short.viewed {
    color: #eee;
    background-color: #aaa;
  }

  button.close-task {
    /* background-color: green; */
    background-color: hsl(39, 60%, 80%);
    border: 0;
    padding: 10px;
    margin: 30px;
    /* border-radius: 5px; */
    border-radius: 0 0 20px 20px;
    color: #fff;
    text-transform: uppercase;
    position: absolute;
    /* right: -30px; */
    right: -30px;
    top: -30px;
    /* width: 20%; */
    /* bottom: 0px; */
  }  

  :global(.card.tip.expanded) {
    background: #fff;
    /* height: 500px; */
  }

  /* The Modal (background) */
  .modal {
    display: hidden; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    padding-top: 100px; /* Location of the box */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  }
</style>

{#if $user.currentTip != tip.id}
    <div
    class="card tip short"
    class:viewed={tip.viewed}
    on:click={() => {
        $user.currentTip = $user.currentTip === tip.id ? -1 : tip.id;
        setTipViewed(tip); // тичер не должен помечать студенческие лекции просмотренными
    }}>
    <div
        class="container bold"
        class:bold={$user.currentTip === tip.id}>
        {tip.name}
    </div>
    </div>
{:else}
    <div
    id="myModal"
    class="modal"
    on:click={() => {
        $user.currentTip = $user.currentTip === tip.id ? -1 : tip.id;        
        vimeoAvailable = false;

        //let video = Wistia.api("1qya69feuu");
        //console.log("W: " + video.percentWatched());
        //console.log("video.duration(): " + video.duration());
        //console.log("video.secondsWatched(): " + video.secondsWatched());
    }}>
    <div
        class="card tip"
        on:click|preventDefault|stopPropagation={() => {}}
        class:expanded={$user.currentTip === tip.id}>
        <i class="fas fa-book" />
        <div
        class="container bold"
        class:bold={$user.currentTip === tip.id}>
        {tip.name}
        </div>
        {#if $user.currentTip === tip.id}
        <div style="text-align: left">
            {@html tip.desc}
        </div>
        <br />
        <br />
        {#if tip.wistia}
            <div>
            <iframe src="https://fast.wistia.net/embed/iframe/{tip.wistia}?autoPlay=true" title="player" allowtransparency="true" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" allowfullscreen mozallowfullscreen webkitallowfullscreen oallowfullscreen msallowfullscreen width="640" height="360"></iframe>
            {#if !vimeoAvailable}
            <div style="display: block;left: 0px; top: -200px; position: relative; color: #9b9">Видео загружается...</div>
            {/if}
            </div>
        {/if}
        {#if tip.voiceCodeCast}
        <!-- <CodeReview /> -->
          <iframe
            target='_parent'
            src="{'https://khasang-codereview.vercel.app?' + tip.voiceCodeCast}"
            allowfullscreen
            mozallowfullscreen
            webkitallowfullscreen
            oallowfullscreen
            msallowfullscreen
            style="border: none; width: 800px; height: 650px;"
            title="voiceCodeCast" />
        {/if}               
        <!-- <iframe
            src="https://fast.wistia.net/embed/iframe/1qya69feuu?fullscreenButton=true"
            allowfullscreen
            mozallowfullscreen
            webkitallowfullscreen
            oallowfullscreen
            msallowfullscreen
            style="border: none; width: 500px; height: 250px;"
            title="some" /> -->

            <!-- console.log('close tip'); -->
            <!-- tip.viewed = true; -->
        <button
            class="close-task"
            on:click|preventDefault|stopPropagation={() => {
            $user.currentTip = $user.currentTip === tip.id ? -1 : tip.id;
            setTipViewed(tip);
            vimeoAvailable = false;
            }}>
            X
        </button>
        {/if}
    </div>
    </div>
{/if}

<!-- <svelte:head>
https://github.com/niutech/x-frame-bypass
 <script src="https://unpkg.com/@ungap/custom-elements-builtin"></script>
 <script type="module" src="https://unpkg.com/x-frame-bypass"></script>
</svelte:head> -->